module.exports = __webpack_public_path__ + "media/customizations/womensleadership/logo-a9a4955b1556e2a669b90db167d82ed6.png";